import { Stack } from "@mui/material";
import { FC } from "react";
import { usePreviousDifferent } from "rooks";
import { alertsCostsAnomalyPreviewTableColumnsDefs } from "./alertsCostsAnomalyPreviewTableColumnsDefs";
import { useAppSelector } from "@/store/hooks";
import { getCostAnomalyPreviewDataGridDataLoadingSelector } from "@/store/alerts/selectors/cost-anomaly-alerts/getCostAnomalyPreviewDataGridDataLoadingSelector";
import { costAnomalyPreviewDataGridDataSelector } from "@/store/alerts/selectors/cost-anomaly-alerts/costAnomalyPreviewDataGridDataSelector";
import { alertsCostAnomalyDataTimeIntervalSelector } from "@/store/alerts/selectors/cost-anomaly-alerts/data/alertsCostAnomalyDataTimeIntervalSelector";
import { AgDataGrid } from "@/components/pages/common/ag-grid/AgDataGrid";

export const AlertsCostsAnomalyPreviewTable: FC = () => {
  const loading = useAppSelector(
    getCostAnomalyPreviewDataGridDataLoadingSelector,
  );
  const gridData = useAppSelector(costAnomalyPreviewDataGridDataSelector);
  const prevData = usePreviousDifferent(gridData);
  const timeInterval = useAppSelector(
    alertsCostAnomalyDataTimeIntervalSelector,
  );

  const data = gridData ?? prevData;

  return (
    <Stack p={1} position="relative" height={250}>
      <AgDataGrid
        rowHeight={37}
        headerHeight={43}
        loading={loading}
        defaultColDef={defaultColDef}
        wrapperStyles={wrapperStyles}
        rowData={!timeInterval ? [] : (data ?? [])}
        columnDefs={alertsCostsAnomalyPreviewTableColumnsDefs}
      />
    </Stack>
  );
};

const defaultColDef = {
  flex: 5,
  minWidth: 180,
  sortable: true,
  unSortIcon: true,
  filter: "agMultiColumnFilter",
};

const wrapperStyles = {
  border: 1,
  borderRadius: 1,
  borderColor: "grey.300",
  "& .ag-root-wrapper": { borderRadius: 1 },

  "& .ag-center-cols-container .ag-row:last-child": {
    borderBottom: "none",
  },
  "& .ag-pinned-left-cols-container .ag-row:last-child": {
    borderBottom: "none",
  },
  "& .ag-pinned-right-cols-container .ag-row:last-child": {
    borderBottom: "none",
  },
};
